import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

import { useAuthStore } from 'modules/auth/core';

import { ReactComponent as Logo404 } from 'assets/images/404.svg';

import { PATH } from 'constants/path';

export const Error404Page = () => {
  const navigationTo = useNavigate();
  const token = useAuthStore().state.auth.token;

  return (
    <Container>
      <Logo404 />
      <Title> 404</Title>
      <Label>Sorry, you are not authorized to access this page.</Label>
      <Button onClick={() => navigationTo(token ? PATH.INSTITUTIONS : PATH.LOGIN)}>
        Back to Dashboard
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
`;

const Title = styled.p`
  font-size: 28px;
  font-weight: 700;
  color: #222222;
  margin-bottom: 4px;
  margin-top: 24px;
`;

const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #8c8c8c;
  margin-bottom: 28px;
  margin-top: 4px;
`;

const Button = styled.button`
  width: 180px;
  height: 50px;
  background-color: #009ef6;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
`;
